// Tepki listesinin istemci-içi güncellenmesi (mimari 9.21.8).
//
// Eskiden her tepki dokunuşundan sonra TÜM konuşma yeniden çekiliyordu
// (`getMessages`): uç nokta sayfalamasız ve tepki toplamı her mesaj için ayrı
// bir alt sorgudan geldiği için maliyet konuşma uzunluğuyla doğrusal büyüyordu —
// tek bir ❤️ binlerce satırı yeniden okutabiliyordu. Artık yalnız o mesajın
// tepki dizisi yerinde hesaplanıyor; istek arka planda gidiyor ve hata olursa
// eski dizi geri konuyor (5 sn'lik yoklama zaten ikinci bir güvence).
//
// Sunucudaki kural şemadan geliyor: `message_reactions` birincil anahtarı
// `(message_id, user_id)` olduğu için bir kullanıcının bir mesajda tek tepkisi
// olur (9.21.7). Buradaki hesap onu birebir taklit eder:
//   - aynı emojiye tekrar basmak     → tepkiyi kaldırır,
//   - farklı emojiye basmak          → mevcut tepkiyi taşır (eskisi düşer),
//   - hiç tepkin yokken basmak       → yeni tepki ekler.

export type Reaction = { emoji: string; count: number; mine: boolean };

export function applyReaction(reactions: Reaction[] | undefined, emoji: string): Reaction[] {
  const mevcut = reactions ?? [];
  const benim = mevcut.find((r) => r.mine);
  const kaldiriliyor = benim?.emoji === emoji;

  const sonuc: Reaction[] = [];
  for (const r of mevcut) {
    let count = r.count;
    let mine = r.mine;
    if (r.mine) {
      // Eski tepkim bu satırdaysa her iki durumda da (kaldırma ya da taşıma)
      // buradan düşer.
      count -= 1;
      mine = false;
    }
    if (!kaldiriliyor && r.emoji === emoji) {
      count += 1;
      mine = true;
    }
    if (count > 0) sonuc.push({ emoji: r.emoji, count, mine });
  }

  // Hiç kimsenin vermediği bir emojiye ilk tepki.
  if (!kaldiriliyor && !mevcut.some((r) => r.emoji === emoji)) {
    sonuc.push({ emoji, count: 1, mine: true });
  }
  return sonuc;
}

// İstek başarısız olduğunda geri dönülecek olan, dokunuştan önceki dizi.
export function isTogglingOff(reactions: Reaction[] | undefined, emoji: string): boolean {
  return (reactions ?? []).some((r) => r.mine && r.emoji === emoji);
}
